(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["evaro-appearance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('evaro-appearance')) {
    customElements.define('evaro-appearance', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.root = document.documentElement;
        this.mode = this.root.dataset.appearance === 'light' ? 'light' : 'dark';
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.button.addEventListener('click', () => this.toggle(), options);
        window.addEventListener('storage', (event) => {
          if (event.key !== 'evaro-appearance' || !['light', 'dark'].includes(event.newValue)) return;
          this.transition?.skipTransition();
          this.mode = event.newValue;
          this.apply();
        }, options);
        this.apply();
        this.hidden = false;
      }
      apply() {
        this.root.dataset.appearance = this.mode;
        this.button.setAttribute('aria-checked', String(this.mode === 'light'));
        this.button.setAttribute('title', this.mode === 'light' ? this.button.dataset.darkTitle : this.button.dataset.lightTitle);
        document.querySelector('meta[name="theme-color"]')?.setAttribute('content', getComputedStyle(this.root).getPropertyValue('--background').trim());
      }
      toggle() {
        this.mode = this.mode === 'light' ? 'dark' : 'light';
        try { localStorage.setItem('evaro-appearance', this.mode); } catch {}
        this.transition?.skipTransition();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!document.startViewTransition || reduced || document.body.classList.contains('motion-paused')) {
          this.apply();
          return;
        }
        const bounds = this.button.getBoundingClientRect();
        this.root.style.setProperty('--theme-origin-x', `${bounds.left + bounds.width / 2}px`);
        this.root.style.setProperty('--theme-origin-y', `${bounds.top + bounds.height / 2}px`);
        try {
          this.transition = document.startViewTransition(() => this.apply());
          this.transition.ready?.catch(() => {});
        } catch { this.apply(); }
      }
      disconnectedCallback() {
        this.events?.abort();
        this.transition?.skipTransition();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evaro-brand-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('evaro-brand-slider')) {
    customElements.define('evaro-brand-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.track = this.querySelector('[data-track]');
        this.items = Array.from(this.track.children);
        this.count = this.items.length;
        if (!this.count) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.pause = this.querySelector('[data-pause]');
        this.interval = Math.max(2, Math.min(8, Number(this.dataset.interval) || 2)) * 1000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.localPaused = false;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.dragging = false;
        this.settling = false;
        this.visible = false;
        this.step = 0;
        const copies = () => this.items.map(item => {
          const copy = item.cloneNode(true);
          copy.dataset.brandClone = 'true';
          copy.setAttribute('aria-hidden', 'true');
          copy.inert = true;
          copy.removeAttribute('id');
          copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          return copy;
        });
        this.track.prepend(...copies());
        this.track.append(...copies());
        this.previous.addEventListener('click', () => this.advance(-1), options);
        this.next.addEventListener('click', () => this.advance(1), options);
        this.pause.addEventListener('click', () => { this.localPaused = !this.localPaused; this.sync(); }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        this.track.addEventListener('pointerdown', () => { this.dragging = true; this.schedule(); }, options);
        const release = () => { if (this.dragging) { this.dragging = false; this.settleSoon(); } };
        window.addEventListener('pointerup', release, options);
        window.addEventListener('pointercancel', release, options);
        this.track.addEventListener('scroll', () => { this.settling = true; this.schedule(); this.settleSoon(); }, { ...options, passive: true });
        this.track.addEventListener('scrollend', () => this.finishScroll(), options);
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.advance(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        const sync = () => this.sync();
        this.reducedMotion.addEventListener('change', sync, options);
        document.addEventListener('visibilitychange', sync, options);
        this.motionObserver = new MutationObserver(sync);
        this.motionObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);
        this.visibilityObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .1 });
        this.visibilityObserver.observe(this);
        this.measure();
        this.setAttribute('data-ready', '');
      }
      measure() {
        const index = ((Number(this.dataset.index) || 0) % this.count + this.count) % this.count;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.step = this.items[0].getBoundingClientRect().width + gap;
        this.cycle = this.step * this.count;
        this.measuredWidth = this.track.clientWidth;
        this.canMove = this.cycle > this.track.clientWidth + gap + 1;
        this.dataset.static = String(!this.canMove);
        this.track.scrollTo({ left: this.canMove ? this.cycle + Math.round(index) * this.step : 0, behavior: 'instant' });
        this.previous.disabled = this.next.disabled = !this.canMove;
        this.finishScroll();
      }
      sync() {
        this.externalPaused = this.reducedMotion.matches || document.body.classList.contains('motion-paused') || this.dataset.autoplay === 'false';
        if ((this.localPaused || this.externalPaused) && this.settling) {
          this.settling = false;
          clearTimeout(this.settleTimer);
          this.track.scrollTo({ left: Math.round(this.track.scrollLeft / this.step) * this.step, behavior: 'instant' });
        }
        this.pause.disabled = this.externalPaused || !this.canMove;
        this.pause.setAttribute('aria-pressed', String(this.localPaused));
        this.dataset.paused = String(this.localPaused || this.externalPaused);
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.canMove || !this.visible || document.hidden || this.localPaused || this.externalPaused || this.hovered || this.focused || this.dragging || this.settling) return;
        this.timer = setTimeout(() => this.advance(1), this.interval);
      }
      advance(direction) {
        if (!this.canMove) return;
        clearTimeout(this.timer);
        this.settling = true;
        const left = (Math.round(this.track.scrollLeft / this.step) + direction) * this.step;
        const instant = this.reducedMotion.matches || document.body.classList.contains('motion-paused');
        this.track.scrollTo({ left, behavior: instant ? 'instant' : 'smooth' });
        this.settleSoon();
      }
      settleSoon() {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.finishScroll(), 180);
      }
      finishScroll() {
        clearTimeout(this.settleTimer);
        if (this.dragging || !this.step) return;
        if (this.measuredWidth !== this.track.clientWidth) { this.measure(); return; }
        if (this.canMove) {
          const offset = ((this.track.scrollLeft - this.cycle) % this.cycle + this.cycle) % this.cycle;
          const normalized = this.cycle + offset;
          if (Math.abs(normalized - this.track.scrollLeft) > 1) this.track.scrollTo({ left: normalized, behavior: 'instant' });
          this.dataset.index = String(Math.round(offset / this.step) % this.count);
        }
        this.settling = false;
        this.sync();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        this.motionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.track?.querySelectorAll('[data-brand-clone]').forEach(copy => copy.remove());
        this.track?.scrollTo({ left: 0, behavior: 'instant' });
        this.removeAttribute('data-ready');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
